"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STOP_DICTATE = void 0;
exports["default"] = stopDictate;
var STOP_DICTATE = 'WEB_CHAT/STOP_DICTATE';
exports.STOP_DICTATE = STOP_DICTATE;

function stopDictate() {
  return {
    type: STOP_DICTATE
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTVE9QX0RJQ1RBVEUiLCJzdG9wRGljdGF0ZSIsInR5cGUiXSwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvYWN0aW9ucy9zdG9wRGljdGF0ZS5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBTVE9QX0RJQ1RBVEUgPSAnV0VCX0NIQVQvU1RPUF9ESUNUQVRFJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gc3RvcERpY3RhdGUoKSB7XG4gIHJldHVybiB7IHR5cGU6IFNUT1BfRElDVEFURSB9O1xufVxuXG5leHBvcnQgeyBTVE9QX0RJQ1RBVEUgfTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBLElBQU1BLFlBQVksR0FBRyx1QkFBckI7OztBQUVlLFNBQVNDLFdBQVQsR0FBdUI7RUFDcEMsT0FBTztJQUFFQyxJQUFJLEVBQUVGO0VBQVIsQ0FBUDtBQUNEIn0=